import { RouteLocationNormalized } from "vue-router"

export default (to: RouteLocationNormalized): boolean | undefined => {
  const isDevelopment = process.env.NODE_ENV === "development"
  const isNexusPsrEnabled = process.env.VUE_APP_USE_NEXUS_PSR === "true"

  if (to.name !== "psr" || isDevelopment || !isNexusPsrEnabled) return

  const toUrl = new URL(window.location.href)
  toUrl.pathname = "/myaccount/priority-services-register"
  window.location.assign(toUrl.toString())
  return false
}
